import * as React from "react";
import { observer, inject } from "mobx-react";
import { QueryRoute } from "bernie-core";
import { Layer } from "bernie-view";
import { TypeaheadSelection } from "uitk-react-typeahead";
import { LocationProps } from "./typings";
import { LocationField } from "../LocationField/LocationField";
import { FlightWizardState } from "stores/wizard/state";
import { SwapLocations } from "../SwapLocations/SwapLocations";

export const Location: React.FunctionComponent<LocationProps> = inject("context", "routeStore")(
  observer(
    ({
      lobState,
      context,
      routeStore,
      originField,
      destinationField,
      l10n,
      classes,
      multiLegIndex,
      showSwapLocationsControl
    }) => {
      if (!context || !routeStore) {
        // Check for injected stores
        return null;
      }

      const locationConfig =
        multiLegIndex !== undefined &&
        lobState instanceof FlightWizardState &&
        lobState.config.multiCityFlight
          ? lobState.config.multiCityFlight.legs[multiLegIndex].location
          : lobState.config.location;
      const locationState =
        multiLegIndex !== undefined &&
        lobState instanceof FlightWizardState &&
        lobState.listOfAdditionalLegs
          ? lobState.listOfAdditionalLegs[multiLegIndex].location
          : lobState.location;

      // TODO: Consolidate functions doing related logic.

      const onOriginLocationFieldUpdate = (selection: TypeaheadSelection) => {
        if (lobState.updateOriginSelection) {
          lobState.updateOriginSelection(selection, multiLegIndex);
        }
      };

      const onDestinationLocationFieldUpdate = (selection: TypeaheadSelection) => {
        lobState.updateDestinationSelection(selection, multiLegIndex);
      };

      const openOriginTypeaheadDialog = () => {
        const pwaDialog =
          (locationConfig.origin && locationConfig.origin.pwaDialogQueryParam) || "default";
        routeStore.updateSearch({ pwaDialog });
      };

      const openDestinationTypeaheadDialog = () => {
        routeStore.updateSearch({
          pwaDialog: locationConfig.destination.pwaDialogQueryParam
        });
      };

      const originTypeaheadDialog = (children: JSX.Element) => {
        const pwaDialog =
          (locationConfig.origin && locationConfig.origin.pwaDialogQueryParam) || "default";

        return (
          <QueryRoute query={{ pwaDialog }}>
            <Layer id="typeahead">{children}</Layer>
          </QueryRoute>
        );
      };

      const swapOriginAndDestination = () => {
        if (lobState.swapLocations) {
          lobState.swapLocations();
        }
      };

      const destinationTypeaheadDialog = (children: JSX.Element) => {
        return (
          <QueryRoute query={{ pwaDialog: locationConfig.destination.pwaDialogQueryParam }}>
            <Layer id="typeahead">{children}</Layer>
          </QueryRoute>
        );
      };

      const closeDialog = () => {
        routeStore.goBack();
      };

      const originInvalidMessage = lobState.originInvalidKey
        ? l10n.formatText(lobState.originInvalidKey)
        : "";
      const destinationInvalidMessage = lobState.destinationInvalidKey
        ? l10n.formatText(lobState.destinationInvalidKey)
        : "";

      const locationClassWithSwap = showSwapLocationsControl ? "locationWithSwap" : "";

      return (
        <div
          className={`Location uitk-grid uitk-cell all-y-gutter-three all-x-gutter-three ${locationClassWithSwap}`}
        >
          {originField &&
            locationConfig.origin && (
              <div className={classes}>
                <LocationField
                  context={context}
                  onClick={openOriginTypeaheadDialog}
                  onDismiss={closeDialog}
                  onUpdate={onOriginLocationFieldUpdate}
                  renderDialog={originTypeaheadDialog}
                  icon={locationConfig.origin.icon}
                  name={
                    lobState instanceof FlightWizardState ? "" : locationConfig.origin.inputName
                  }
                  label={l10n.formatText(locationConfig.origin.labelToken)}
                  invalid={originInvalidMessage}
                  value={locationState.origin.value}
                  l10n={l10n}
                  isDest={false}
                  essAdapterConfig={locationConfig.origin.essAdapterConfig}
                  stid={`location-field-${locationConfig.origin.inputName}`}
                  config={locationConfig.origin}
                  location={locationState.origin}
                />
              </div>
            )}
          {showSwapLocationsControl && <SwapLocations swapLocations={swapOriginAndDestination} />}
          {destinationField &&
            locationConfig.destination && (
              <div className={classes}>
                <LocationField
                  context={context}
                  onClick={openDestinationTypeaheadDialog}
                  onDismiss={closeDialog}
                  onUpdate={onDestinationLocationFieldUpdate}
                  renderDialog={destinationTypeaheadDialog}
                  icon={locationConfig.destination.icon}
                  name={
                    lobState instanceof FlightWizardState
                      ? ""
                      : locationConfig.destination.inputName
                  }
                  label={l10n.formatText(locationConfig.destination.labelToken)}
                  invalid={destinationInvalidMessage}
                  value={locationState.destination.value}
                  l10n={l10n}
                  isDest={true}
                  essAdapterConfig={locationConfig.destination.essAdapterConfig}
                  stid={`location-field-${locationConfig.destination.inputName}`}
                  config={locationConfig.destination}
                  location={locationState.destination}
                />
              </div>
            )}
        </div>
      );
    }
  )
);
